export default theme => ({
  topbar: {
    position: 'fixed',
    width: '100%',
    top: 0,
    left: 0,
    right: 'auto',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  // Ensure the sidebar overlays the topbar on small screens
  topbarShift: {
    marginLeft: '271px',
    width: 'calc(-271px + 100vw)'
  },
  drawerPaper: {
    zIndex: 2500,
    width: '271px',
    overflowX: 'hidden',
    position: 'fixed',
    top: 0,
    height: '100vh',
    backgroundColor: theme.palette.background.default,
  },
  sidebar: {
    width: '255px'//we have padding also that will complete to 271px
  },
  content: {
    marginTop: '64px',
    minHeight: '100vh',
    backgroundColor: theme.palette.background.default,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  // On desktop, shift content to make room for persistent drawer; on mobile, we always use temporary drawer
  contentShift: {
    marginLeft: '270px'
  }
});
